/* eslint-disable no-magic-numbers */
import { axiosInstance } from './instance';
import { setUpAuthInterceptors } from './interceptors/authInterceptors';
import { setUpErrorsInterceptors } from './interceptors/errorsInterceptors';

export const setUpInterceptors = () => {
  setUpAuthInterceptors(axiosInstance);
  setUpErrorsInterceptors(axiosInstance);
};
